import axios from "axios";
import { getAccessToken, getReqParams, formatfbInsightsData, formatfbImpressionsData } from "./utils.js";
import { getUrl } from "./urls";
import store from "../store";
import { toast } from "react-toastify";
var moment = require("moment");
export const FETCH_TOTAL_PAGE_VIEW = "FETCH_TOTAL_PAGE_VIEW";
export const FETCH_TOTAL_PAGE_LIKE = "FETCH_TOTAL_PAGE_LIKE";
export const FETCH_TOTAL_PAGE_ENGAGEMENT = "FETCH_TOTAL_PAGE_ENGAGEMENT";
export const FETCH_TOTAL_PAGE_REACH = "FETCH_TOTAL_PAGE_REACH";
export const FETCH_PAGE_VIEW_BY_SECTION = "FETCH_PAGE_VIEW_BY_SECTION";
export const FETCH_PAGE_LIKES_BY_LIKE = "FETCH_PAGE_LIKES_BY_LIKE";
export const FETCH_PAGE_LIKES_BY_SOURCE = "FETCH_PAGE_LIKES_BY_SOURCE";
export const FETCH_PAGE_VIEW_BY_DEVICE = "FETCH_PAGE_VIEW_BY_DEVICE";
export const FETCH_AUDIENCE_BY_AGE_AND_GENDER = "FETCH_AUDIENCE_BY_AGE_AND_GENDER";
export const FETCH_AUDIENCE_BY_COUNTRIES = "FETCH_AUDIENCE_BY_COUNTRIES";
export const UPDATE_FBINSIGHTS_DURATION = "UPDATE_FBINSIGHTS_DURATION";
export const SET_PAGE_VIEW_TAB_INDEX = "SET_PAGE_VIEW_TAB_INDEX";
export const SET_PAGE_LIKES_TAB_INDEX = "SET_PAGE_LIKES_TAB_INDEX";
export const FETCH_TOTAL_POST_LIKES = "FETCH_TOTAL_POST_LIKES";
export const STORE_FB_LOGIN_DETAILS = "STORE_FB_LOGIN_DETAILS";
export const SAVE_SELECTED_FB_PAGE_IDS = "SAVE_SELECTED_FB_PAGE_IDS";
export const SET_SELECTED_FB_PAGE = "SET_SELECTED_FB_PAGE";
export const FB_PAGE_TOKEN_LIST_FETCHING = "FB_PAGE_TOKEN_LIST_FETCHING";
export const SET_VIEW_GRID_LINES = "SET_VIEW_GRID_LINES";
export const SET_VIEW_UNIQUE_LINES = "SET_VIEW_UNIQUE_LINES";
export const SET_FOLLOWERS_GRID_LINES = "SET_FOLLOWERS_GRID_LINES";
export const SET_FOLLOWERS_UNIQUE_LINES = "SET_FOLLOWERS_UNIQUE_LINES";
export const SET_REACH_GRID_LINES = "SET_REACH_GRID_LINES";
export const SET_REACH_UNIQUE_LINES = "SET_REACH_UNIQUE_LINES";
export const SET_ENGAGEMENT_GRID_LINES = "SET_ENGAGEMENT_GRID_LINES";
export const SET_ENGAGEMENT_UNIQUE_LINES = "SET_ENGAGEMENT_UNIQUE_LINES";
export const SET_POSTS_LIKES_GRID_LINES = "SET_POSTS_LIKES_GRID_LINES";
export const FB_PAGE_TOKEN_LIST = "FB_PAGE_TOKEN_LIST";
export const FETCH_FB_TOTAL_CHART_DATA = "FETCH_FB_TOTAL_CHART_DATA";
export const FETCH_FB_RECENT_POSTS = "FETCH_FB_RECENT_POSTS";
export const FETCH_FB_POST_TYPES = "FETCH_FB_POST_TYPES";
export const FETCH_FB_PAGE_FOLLOWERS = "FETCH_FB_PAGE_FOLLOWERS";

export function updateFbInsightsDuration(dispatch, duration) {
    dispatch({
        type: "UPDATE_FBINSIGHTS_DURATION",
        payload: duration,
    });
}

// export function setPageViewTabIndex(dispatch, tabIndex) {
//     dispatch({
//         type: SET_PAGE_VIEW_TAB_INDEX,
//         payload: tabIndex,
//     });
// }

export function setPageLikesTabIndex(dispatch, tabIndex) {
    dispatch({
        type: SET_PAGE_LIKES_TAB_INDEX,
        payload: tabIndex,
    });
}

export function fetchFbPageViewData(dispatch, data, chartName, aggs_val, selectedFbPage, is_unique) {
    if (chartName == "totalViews") {
        fetchTotalViewsOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);
    } else if (chartName == "totalViewsBySection") {
        fetchTotalViewsBySectionOverTime(dispatch, data, aggs_val, selectedFbPage);
    } else if (chartName == "totalViewsByDevice") {
        fetchTotalViewsByDeviceOverTime(dispatch, data, aggs_val, selectedFbPage);
    }
}

export function fetchFbPageLikesData(dispatch, data, chartName, aggs_val, selectedFbPage, is_unique) {
    if (chartName == "totalLikes") {
        fetchTotalLikesOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);
    } else if (chartName == "totalLikesByLike") {
        fetchTotalLikesByLikeOverTime(dispatch, data, aggs_val, selectedFbPage);
    } else if (chartName == "totalLikesBySource") {
        fetchTotalLikesBySourceOverTime(dispatch, data, aggs_val, selectedFbPage);
    }
}

export function fetchFbPageEngagementData(dispatch, data, chartName, aggs_val, selectedFbPage, is_unique, isAverage) {
    if (chartName == "totalEngagement") {
        // if (!isAverage) fetchTotalEngagementOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);
        // else fetchAverageTotalEngagementOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);

        fetchFbPageEngagementData1(dispatch, data, aggs_val, selectedFbPage);
    }
}
export function fetchFbPostComments(dispatch, data, chartName, aggs_val, selectedFbPage, is_unique, isAverage) {
    if (chartName == "totalEngagement") {
        // if (!isAverage) fetchTotalEngagementOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);
        // else fetchAverageTotalEngagementOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);

        fetchFbPostCommentsData(dispatch, data, aggs_val, selectedFbPage);
    }
}
export function fetchFbPostShares(dispatch, data, chartName, aggs_val, selectedFbPage, is_unique, isAverage) {
    if (chartName == "totalEngagement") {
        // if (!isAverage) fetchTotalEngagementOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);
        // else fetchAverageTotalEngagementOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);

        fetchFbPostSharesData(dispatch, data, aggs_val, selectedFbPage);
    }
}

export function fetchFbPostLikesData(dispatch, data, chartName, aggs_val, selectedFbPage, is_unique, isAverage) {
    if (chartName == "totalPostLikes") {
        // if (!isAverage) fetchTotalPostLikesOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);
        // else fetchAverageTotalPostLikesOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);
        fetchTotalPostLikesOverTime1(dispatch, data, aggs_val, selectedFbPage);
    }
}

export function fetchFbPageReachData(dispatch, data, chartName, aggs_val, selectedFbPage, is_unique) {
    if (chartName == "totalReach") {
        fetchTotalReachOverTime(dispatch, data, is_unique, aggs_val, selectedFbPage);
    }
}

let fetchTotalViewsOverTime = (dispatch, data, is_unique, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_view_by_total");
    if (is_unique) {
        params.append("is_unique", is_unique);
    }
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_PAGE_VIEW",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, is_unique ? "totalUniqueViews" : "totalViews", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchTotalLikesOverTime = (dispatch, data, is_unique, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_follower_by_total");
    if (is_unique) {
        params.append("is_unique", is_unique);
    }
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_PAGE_LIKE",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, is_unique ? "totalUniqueLikes" : "totalLikes", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchTotalEngagementOverTime = (dispatch, data, is_unique, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_engagement_by_total");
    if (is_unique) {
        params.append("is_unique", is_unique);
    }
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_PAGE_ENGAGEMENT",
                payload: formatfbInsightsData(
                    response.data,
                    data.startDateTime,
                    data.endDateTime,
                    is_unique ? "totalUniqueEngagement" : "totalEngagement",
                    aggs_val,
                ),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchAverageTotalEngagementOverTime = (dispatch, data, is_unique, aggs_val, selectedFbPage) => {
    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_engagement_by_total");
    if (is_unique) {
        params.append("is_unique", is_unique);
    }
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            const countData = response.data?.total;

            let params = new URLSearchParams();

            params.append("start_date", data.startDateTime);
            params.append("end_date", data.endDateTime);
            params.append("data", "0");
            params.append("orderBy", "post.published_date");
            params.append("order", "desc");
            params.append("offset", "1");
            params.append("recordsPerPage", "50");
            params.append("post_type", "0");
            params.append("aggs-interval", interval);
            params.append("aggs", "conversation-over-time");
            params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
            params.append("custom_query", `handlers.value:"${selectedFbPage.handler}"`);

            axios
                .post(getUrl("searchaggs"), params, {
                    cache: false,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    },
                })
                .then((response) => {
                    dispatch({
                        type: "FETCH_TOTAL_PAGE_ENGAGEMENT",
                        payload: formatfbInsightsData(
                            { postData: response.data?.aggregations?.conversation_over_time?.buckets, countData },
                            data.startDateTime,
                            data.endDateTime,
                            "totalAverageEngagement",
                            aggs_val,
                        ),
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchFbPageEngagementData1 = (dispatch, data, aggs_val, selectedFbPage) => {
    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }

    let params = new URLSearchParams();
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "comments_datewise_breakdown,shares_datewise_breakdown,reactions_datewise_breakdown");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    let page = selectedFbPage?.handler.replace(/['"]+/g, "");
    params.append("custom_query", `handlers.value:"${page}"`);

    axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_PAGE_ENGAGEMENT",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, "totalAverageEngagement", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};
export const fetchFbPageFollowersData = (dispatch, data, aggs_val, selectedFbPage) => {
    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }

    const users = [
        {
            username: selectedFbPage?.handler,
            platform: "facebook",
        },
    ];

    const data1 = {
        start_date: data.startDateTime,
        end_date: data.endDateTime,
        interval,
        users,
        show_bucket: true,
    };

    axios
        .post(getUrl("competitor_follower"), data1, {
            cache: false,
        })
        .then((res) => {
            dispatch({
                type: "FETCH_TOTAL_PAGE_FOLLOWERS_DATA",
                payload: formatfbInsightsData(res.data?.results?.[0], data.startDateTime, data.endDateTime, "pageFollowersData", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchFbPageEngagementRateData = (dispatch, data, aggs_val, selectedFbPage) => {
    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }
    // let params1 = new URLSearchParams();
    // // params1.append("page_id", selectedFbPage?.value);
    // // params1.append("filter_type", "fb_page_follower_by_total");
    // params1.append("start_date", data.startDateTime);
    // params1.append("end_date", data.endDateTime);
    // params1.append("users", interval);

    // params1.append("users", users);

    const users = [
        {
            username: selectedFbPage?.handler,
            platform: "facebook",
        },
    ];

    const data1 = {
        start_date: data.startDateTime,
        end_date: data.endDateTime,
        interval,
        users,
        show_bucket: true,
    };

    const followersData = axios
        .post(getUrl("competitor_follower"), data1, {
            cache: false,
        })
        .then((res) => ({ name: "followersData", data: res.data?.results?.[0] }));

    let params = new URLSearchParams();
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "comments_datewise_breakdown,shares_datewise_breakdown,reactions_datewise_breakdown");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    let page = selectedFbPage?.handler.replace(/['"]+/g, "");
    params.append("custom_query", `handlers.value:"${page}"`);

    const engagementData = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((res) => ({ name: "engagementData", data: res.data }));
    Promise.all([followersData, engagementData])
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_PAGE_ENGAGEMENT_RATE",
                payload: formatfbInsightsData(response, data.startDateTime, data.endDateTime, "postEngagementRate", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchFbPostCommentsData = (dispatch, data, aggs_val, selectedFbPage) => {
    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }

    let params = new URLSearchParams();
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "comments_datewise_breakdown");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    let page = selectedFbPage?.handler.replace(/['"]+/g, "");
    params.append("custom_query", `handlers.value:"${page}"`);

    axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_POST_COMMENTS",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, "totalPostComments", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchFbPostSharesData = (dispatch, data, aggs_val, selectedFbPage) => {
    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }

    let params = new URLSearchParams();
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "shares_datewise_breakdown");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    let page = selectedFbPage?.handler.replace(/['"]+/g, "");
    params.append("custom_query", `handlers.value:"${page}"`);

    axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_POST_SHARES",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, "totalPostShares", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchAverageTotalPostLikesOverTime = (dispatch, data, is_unique, aggs_val, selectedFbPage) => {
    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_post_reaction");
    if (is_unique) {
        params.append("is_unique", is_unique);
    }
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            const countData = response.data;

            let params = new URLSearchParams();

            params.append("start_date", data.startDateTime);
            params.append("end_date", data.endDateTime);
            params.append("data", "0");
            params.append("orderBy", "post.published_date");
            params.append("order", "desc");
            params.append("offset", "1");
            params.append("recordsPerPage", "50");
            params.append("post_type", "0");
            params.append("aggs-interval", interval);
            params.append("aggs", "conversation-over-time");
            params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
            params.append("custom_query", `handlers.value:"${selectedFbPage.handler}"`);

            axios
                .post(getUrl("searchaggs"), params, {
                    cache: false,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    },
                })
                .then((response) => {
                    dispatch({
                        type: "FETCH_TOTAL_POST_LIKES",
                        payload: formatfbInsightsData(
                            { postData: response.data?.aggregations?.conversation_over_time?.buckets, countData },
                            data.startDateTime,
                            data.endDateTime,
                            "totalAveragePostLikes",
                            aggs_val,
                        ),
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchTotalPostLikesOverTime = (dispatch, data, is_unique, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_post_reaction");
    if (is_unique) {
        params.append("is_unique", is_unique);
    }
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_POST_LIKES",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, "totalPostLikes", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchTotalPostLikesOverTime1 = (dispatch, data, aggs_val, selectedFbPage) => {
    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }

    let params = new URLSearchParams();
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "reactions_datewise_breakdown");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    let page = selectedFbPage?.handler.replace(/['"]+/g, "");
    params.append("custom_query", `handlers.value:"${page}"`);

    axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_POST_LIKES",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, "totalPostLikes", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchTotalReachOverTime = (dispatch, data, is_unique, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_reach_by_total");
    if (is_unique) {
        params.append("is_unique", is_unique);
    }
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_TOTAL_PAGE_REACH",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, is_unique ? "totalUniqueReach" : "totalReach", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchTotalViewsBySectionOverTime = (dispatch, data, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_view_by_section");
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_PAGE_VIEW_BY_SECTION",
                // payload: response.data,
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, null, aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};
let fetchTotalLikesByLikeOverTime = (dispatch, data, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_like_by_type");
    params.append("is_unique", true);
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({ type: "FETCH_PAGE_LIKES_BY_LIKE", payload: response.data });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchTotalLikesBySourceOverTime = (dispatch, data, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_like_by_source");
    if (is_unique) {
        params.append("is_unique", is_unique);
    }
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_PAGE_LIKES_BY_SOURCE",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, null, aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

let fetchTotalViewsByDeviceOverTime = (dispatch, data, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_view_by_device");
    params.append("is_unique", true);
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({ type: "FETCH_PAGE_VIEW_BY_DEVICE", payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, null, aggs_val) });
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchAudienceByAgeAndGender = (dispatch, data, is_unique, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    // params.append('page_id', '575042275846072')
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_follower_by_gender_age");
    // params.append("is_unique", true);
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_AUDIENCE_BY_AGE_AND_GENDER",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, "fbTotalAudienceByAge", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchAudienceByTopCountries = (dispatch, data, is_unique, aggs_val, selectedFbPage) => {
    let params = new URLSearchParams();
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", data.startDateTime);
    params.append("end_date", data.endDateTime);
    params.append("agreegate_interval", aggs_val);
    params.append("filter_type", "fb_page_follower_by_country");
    // params.append("is_unique", true);
    let res = axios
        .post(getUrl("socialInsights"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_AUDIENCE_BY_COUNTRIES",
                payload: formatfbInsightsData(response.data, data.startDateTime, data.endDateTime, "fbTotalAudienceByCountry", aggs_val),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

export function storeFacebookLoginDetails(dispatch, data) {
    dispatch({
        type: "STORE_FB_LOGIN_DETAILS",
        payload: data,
    });
}

// export function fetchSelectedFbPages(dispatch, platform_id, company_id, selectedFbPage) {
//     let fbAccessToken = store.getState().fbInsightsReducer.fbAccessToken;
//     let page_ids = [];
//     let page_details = JSON.parse(JSON.stringify(store.getState().fbInsightsReducer.fbSelectedPageIds));
//     axios.get("https://graph.facebook.com/me?fields=accounts&access_token=" + fbAccessToken).then((response) => {
//         response.data.accounts &&
//             response.data.accounts.data.map((k, v) => {
//                 page_ids.push(k.id);
//                 if (!page_details.find((elem) => elem.id == k.id)) {
//                     page_details.push({ id: k.id, name: k.name, status: "Active", expiry_date: k.token_expires_at });
//                 }
//             });
//         //dispatch({ type: "SAVE_SELECTED_FB_PAGE_IDS", payload: page_ids });
//         let params = {
//             fb_access_token: fbAccessToken,
//             company_id: company_id,
//             platform_id: platform_id,
//             page_id: page_ids,
//             app_name: "20twentyapp",
//         };
//         return axios
//             .post(getUrl("createFbPageToken"), params, {
//                 cache: false,
//                 headers: {
//                     "Content-Type": "application/json; charset=UTF-8",
//                 },
//             })
//             .then((res) => {
//                 res.data.data.map((key, val) => {
//                     if (key.status) {
//                         if (selectedFbPage && selectedFbPage?.value === key.page_id) {
//                             selectedFbPage.status = "Active";
//                             selectedFbPage.expiry_date = key.token_expires_at;
//                         }
//                         toast.success(`Successfully connected the "${key.data.page_name}" page`);
//                     } else if (!key.status && key.error) {
//                         toast.error(page_details.find((elem) => elem.id == key.page_id).name + " " + key.error);
//                     }
//                 });
//                 // return res.data.data;
//                 //
//                 dispatch({ type: "FB_PAGE_TOKEN_LIST_FULFILLED", payload: page_details });
//                 dispatch({ type: "SET_SELECTED_FB_PAGE", payload: selectedFbPage });
//                 dispatch(fetchFbPageTokens(platform_id, company_id));
//             })
//             .catch((err) => {
//                 if (err.response.data.message) {
//                     toast.error(err.response.data.message);
//                 } else toast.error("Error in Authorizing");
//             });
//     });
// }

export function show_loader(dispatch) {
    dispatch({ type: "FB_PAGE_TOKEN_LIST_FETCHING", payload: true });
}

export function fetchFbPageTokens(platform_id, company_id) {
    let page_details = [];
    let req = axios
        .get(getUrl("social_token_list"))
        .then((response) => {
            response.data.data.tokens.map((k, v) => {
                if (k.platform === "facebook" && k.insight_feature === 1) {
                    page_details.push({
                        id: k.page_id,
                        name: k.page_name,
                        username: k.page_username,
                        status: k.status,
                        expiry_date: k.token_expires_at,
                        access_token: k.access_token,
                        handler: k.page_username,
                    });
                }
            });

            return page_details;
        })
        .catch((err) => {
            console.log(err);
            if (err.response && err.response.data && err.response.data.message) {
                toast.error(err.response.data.message);
            } else toast.error("Some error occured");
        });

    return {
        type: "FB_PAGE_TOKEN_LIST",
        payload: req,
    };
}

export function fetchFbPageTokensClone(platform_id, company_id) {
    return function (dispatch) {
        let page_ids = [];
        let page_details = [];
        axios.get(getUrl("fbPageTokenList") + "&company_id=" + company_id + "&platform_id=" + platform_id).then((response) => {
            response.data.data.map((k, v) => {
                page_ids.push(k.page_id);
                page_details.push({ id: k.page_id, name: k.page_name, status: k.status, expiry_date: k.token_expires_at });
            });
            dispatch({ type: "SAVE_SELECTED_FB_PAGE_IDS", payload: page_details });
        });
    };
}

export function setSelectedFbPage(dispatch, val) {
    dispatch({
        type: "SET_SELECTED_FB_PAGE",
        payload: val,
    });
}

export function setViewGridLine() {
    return {
        type: "SET_VIEW_GRID_LINES",
    };
}
export function setViewUniqueLine() {
    return {
        type: "SET_VIEW_UNIQUE_LINES",
    };
}
export function setFollowersGridLine() {
    return {
        type: "SET_FOLLOWERS_GRID_LINES",
    };
}
export function setFollowersUniqueLine() {
    return {
        type: "SET_FOLLOWERS_UNIQUE_LINES",
    };
}
export function setEngagementGridLine() {
    return {
        type: "SET_ENGAGEMENT_GRID_LINES",
    };
}
export function setEngagementUniqueLine() {
    return {
        type: "SET_ENGAGEMENT_UNIQUE_LINES",
    };
}

export function setReachGridLine() {
    return {
        type: "SET_REACH_GRID_LINES",
    };
}
export function setReachUniqueLine() {
    return {
        type: "SET_REACH_UNIQUE_LINES",
    };
}
export function setPostsLikeGridLine() {
    return {
        type: "SET_POSTS_LIKES_GRID_LINES",
    };
}

export function resetFBInsightsPage() {
    return {
        type: "RESET_FB_INSIGHTS_PAGE",
    };
}

const getPreviousTotalData = async (filter) => {
    const startDate = moment(filter.start_date);
    const endDate = moment(filter.end_date);

    const duration = moment.duration(endDate.diff(startDate, "days")) + 1;

    let newStartDate = startDate.subtract(duration, "days").format();

    let params = {};
    params["page_id"] = filter.page_id;
    params["start_date"] = newStartDate;
    params["end_date"] = filter.start_date;
    params["agreegate_interval"] = filter.agreegate_interval;
    params["filter_type"] = filter.filter_type;
    if (filter.is_unique) {
        params["is_unique"] = filter.is_unique;
    }

    return await axios
        .post(getUrl("socialInsights"), params, {
            headers: {
                "Content-type": "application/json",
            },
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.log(err);
        });
};

export const getTotalValuesData = (data, chartName, chartKey, aggs_val, selectedFbPage, is_unique) => {
    return (dispatch) => {
        let params = {};
        params["page_id"] = selectedFbPage?.value;
        params["start_date"] = data.startDateTime;
        params["end_date"] = data.endDateTime;
        params["agreegate_interval"] = aggs_val;
        params["filter_type"] = chartName;
        if (is_unique) {
            params["is_unique"] = is_unique;
        }

        const previousDataPromise = getPreviousTotalData(params);

        dispatch({ type: "FETCH_FB_TOTAL_CHART_DATA_PENDING", chartKey });

        const currentDataPromise = axios.post(getUrl("socialInsights"), params, {
            headers: {
                "Content-type": "application/json",
            },
        });

        const allPromise = Promise.all([previousDataPromise, currentDataPromise]);
        allPromise
            .then((res) => {
                dispatch({
                    type: "FETCH_FB_TOTAL_CHART_DATA_FULFILLED",
                    chartKey,
                    payload: formatfbInsightsData(res, data.startDateTime, data.endDateTime, chartName, chartKey),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_FB_TOTAL_CHART_DATA_REJECTED", chartKey, payload: err });
                return err;
            });
    };
};
const getFbTotalPageViews = (startDateTime, endDateTime, aggsVal, selectedFbPage) => {
    let params = new URLSearchParams();
    params.append("page_id", selectedFbPage?.value);
    params.append("start_date", startDateTime);
    params.append("end_date", endDateTime);
    params.append("agreegate_interval", "yearly");
    params.append("filter_type", aggsVal);

    return axios.post(getUrl("socialInsights"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};
const getDataPromise = (startDateTime, endDateTime, aggsVal, selectedFbPage) => {
    let params = new URLSearchParams();
    // if (blockType === "fbTotalPageReachBlock") console.log("hereeee", aggsVal);
    if (aggsVal !== "fbTotalPostsBlock") {
        params.append("aggs-interval", "year");
        params.append("aggs", aggsVal);
    }
    params.append("start_date", startDateTime);
    params.append("end_date", endDateTime);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    let page = selectedFbPage?.handler.replace(/['"]+/g, "");
    params.append("custom_query", `handlers.value:"${page}"`);

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};

export const fetchFbPostDetails = (dispatch, data, blockType, selectedFbPage) => {
    const startDate = moment(data.startDateTime);
    const endDate = moment(data.endDateTime);
    const duration = moment.duration(endDate.diff(startDate, "days")) + 1;
    let newStartDate = startDate.subtract(duration, "days").format();
    let aggsVal = null;
    let apiCall = blockType === "fbTotalPageViewsBlock" || blockType === "fbTotalPageReachBlock" ? getFbTotalPageViews : getDataPromise;

    switch (blockType) {
        case "fbTotalPostCommentsBlock":
            aggsVal = "comments_datewise_breakdown";
            break;
        case "fbTotalPageViewsBlock":
            aggsVal = "fb_page_view_by_total";
            break;
        case "fbTotalPostSharesBlock":
            aggsVal = "shares_datewise_breakdown";
            break;

        case "fbTotalPostReactionsBlock":
            aggsVal = "reactions_datewise_breakdown";
            break;
        case "fbTotalPostsBlock":
            aggsVal = "fbTotalPostsBlock";
            break;
        case "fbTotalPageReachBlock":
            aggsVal = "fb_page_reach_by_total";
            break;

        case "fbTotalEngagementBlock":
            aggsVal = "comments_datewise_breakdown,shares_datewise_breakdown,reactions_datewise_breakdown";
            break;

        default:
            break;
    }

    const presentDurationData = apiCall(data.startDateTime, data.endDateTime, aggsVal, selectedFbPage).then((res) => ({
        name: "presentDurationData",
        data: res.data,
    }));
    const previousDurationData = apiCall(newStartDate, data.startDateTime, aggsVal, selectedFbPage).then((res) => ({
        name: "previousDurationData",
        data: res.data,
    }));

    Promise.all([presentDurationData, previousDurationData])
        .then((response) => {
            // console.log("bach gya!!", response);
            dispatch({
                // type: `${dispatchType}`,
                type: "FETCH_ALL_POST_DETAILS_FOR_CHART_BLOCKS",
                payload: formatfbInsightsData(response, data.startDateTime, data.endDateTime, blockType, blockType, duration),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};
export function fetchFbPageFollowers(params) {
    let res = axios({
        method: "get",
        url: `https://graph.facebook.com/v12.0/${params.page_id}?fields=followers_count&access_token=${params.access_token}`,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message);
            return err;
        });
    return {
        type: "FETCH_FB_PAGE_FOLLOWERS",
        payload: res,
    };
}

export const fetchRecentPostsData = (dispatch, filter, selectedPage, postOrder, postOrderBy) => {
    let params = new URLSearchParams();

    let order = postOrder,
        orderBy = postOrderBy;

    params.append("start_date", filter.startDateTime);
    params.append("end_date", filter.endDateTime);
    params.append("data", "1");
    params.append("orderBy", orderBy);
    params.append("order", order);
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("exclude_dark_post", "1");
    params.append("post_type", "0");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    // params.append("custom_query", `post.page_id:${selectedPage.value}`);
    let Page = selectedPage?.handler.replace(/['"]+/g, "");
    params.append("custom_query", `handlers.value:"${Page}"`);

    let res = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_FB_RECENT_POSTS",
                payload: formatfbInsightsData(response.data?.hits?.hits, filter.startDateTime, filter.endDateTime, "fbRecentPosts", null),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchPostOvertime = (dispatch, filter, selectedPage, aggs_val) => {
    // console.log("selectedPage.handler", selectedPage.handler);
    let params = new URLSearchParams();

    let order, orderBy;
    order = "desc";
    orderBy = "post.published_date";

    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else interval = "day";
    }

    params.append("start_date", filter.startDateTime);
    params.append("end_date", filter.endDateTime);
    params.append("data", "0");
    params.append("orderBy", orderBy);
    params.append("order", order);
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs", "conversation-over-time");
    params.append("aggs-interval", interval);
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    // params.append("custom_query", `post.page_id:${selectedPage.value}`);
    params.append("custom_query", `handlers.value:"${selectedPage.handler}"`);

    axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_FB_POSTS_OVERTIME",
                payload: formatfbInsightsData(
                    response.data?.aggregations?.conversation_over_time?.buckets,
                    filter.startDateTime,
                    filter.endDateTime,
                    "fbPostOvertime",
                    null,
                ),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchImpressionOvertime = (dispatch, filter, chartName, aggs_val, selectedFbpage, chartKey) => {
    console.log("selectedPage.handler", filter, chartName, chartKey, aggs_val, selectedFbpage);
    let params = {};

    let order, orderBy;
    order = "desc";
    orderBy = "post.published_date";

    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = aggs_val;
        else if (aggs_val === "monthly") interval = aggs_val;
        else if (aggs_val === "weekly") interval = aggs_val;
        else interval = "daily";
    }

    params["start_date"] = filter.startDateTime;
    params["end_date"] = filter.endDateTime;
    params["orderBy"] = orderBy;
    params["order"] = order;
    params["aggs"] = ["impression_metrics"];
    params["agreegate_interval"] = interval;
    params["page_id"] = selectedFbpage.id;

    axios

        .post(getUrl("facebook_impression"), params, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "access-token": getAccessToken(),
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_FB_IMPRESSION_OVERTIME",
                payload: formatfbImpressionsData(response.data?.impression_metrics, filter.startDateTime, filter.endDateTime, "fbImpressionOvertime", null),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchTotalEngagementData = (dispatch, filter, selectedPage, aggs_val) => {
    let eng1 = getEngagementAgg(filter, selectedPage).then((res) => ({ name: "eng1", data: res.data }));

    let filter2 = JSON.parse(JSON.stringify(filter));
    let durationGap = moment(filter2.endDateTime).diff(moment(filter2.startDateTime), "days", true);

    filter2["startDateTime"] = moment(filter2.startDateTime)
        .subtract(durationGap + 1, "days")
        .startOf("day")
        .format("YYYY-MM-DD");

    filter2["endDateTime"] = moment(filter.startDateTime).subtract(1, "day").format("YYYY-MM-DD");

    let eng2 = getEngagementAgg(filter2, selectedPage).then((res) => ({ name: "eng2", data: res.data }));

    durationGap = +durationGap.toFixed(0);

    Promise.all([eng1, eng2])
        .then((response) => {
            dispatch({
                type: "FETCH_FB_TOTAL_CHART_DATA_FULFILLED",
                chartKey: "fbTotalEngagementCount",
                payload: { data: formatfbInsightsData(response, filter.startDateTime, filter.endDateTime, "fbTotalEngagementCount", null), durationGap },
            });
        })
        .catch((error) => {
            console.log(error);
        });
};

const getEngagementAgg = (filter, selectedPage) => {
    let params = new URLSearchParams();

    let order, orderBy;
    order = "desc";
    orderBy = "post.published_date";

    params.append("start_date", filter.startDateTime);
    params.append("end_date", filter.endDateTime);
    params.append("data", "0");
    params.append("orderBy", orderBy);
    params.append("order", order);
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs", "comments_datewise_breakdown,shares_datewise_breakdown,reactions_datewise_breakdown");
    params.append("aggs-interval", "month");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedPage.handler}"`);

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};

export const fetchPostTypeDistribution = (dispatch, filter, selectedPage) => {
    let params = new URLSearchParams();

    params.append("start_date", filter.startDateTime);
    params.append("end_date", filter.endDateTime);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "20");
    params.append("custom_query", `post.page_id:${selectedPage.value}`);
    params.append("aggs", "post-media-breakup");

    let res = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            dispatch({
                type: "FETCH_FB_POST_TYPES",
                payload: formatfbInsightsData(
                    response.data?.aggregations?.post_media_breakup?.buckets,
                    filter.startDateTime,
                    filter.endDateTime,
                    "fbPostTypeDistribution",
                    null,
                ),
            });
        })
        .catch((error) => {
            console.log(error);
        });
};
